__turbopack_context__.v({
  "animation": "umTi3q_animation",
  "covered": "umTi3q_covered",
});
